/**
 * Helpers Functions
 */

import moment from 'moment';

// Get Date
export function getTheDate(timestamp, format) {
	let time = timestamp * 1000;
	let formatDate = format ? format : 'MM-DD-YYYY';
	return moment(time).format(formatDate);
}

// Convert Date To Timestamp
export function convertDateToTimeStamp(date, format) {
	let formatDate = format ? format : 'YYYY-MM-DD';
	return moment(date, formatDate).unix();
}

/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
	if (length == null) {
		length = 100;
	}
	if (ending == null) {
		ending = '...';
	}
	if (str.length > length) {
		return str.substring(0, length - ending.length) + ending;
	} else {
		return str;
	}
}

/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
	let c;
	if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
		c = hex.substring(1).split('');
		if (c.length === 3) {
			c = [c[0], c[0], c[1], c[1], c[2], c[2]];
		}
		c = '0x' + c.join('');
		return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
	}
	throw new Error('Bad Hex');
}

/**
 * Function to return currenr app layout
 */
export function getCurrentAppLayout(router) {
	let location = router.history.current.fullPath;
	let path = location.split("/")
	return path[1];
}


/**
 * Función para oscurecer o aclarar un color Hexadecimal
 * @param color String - Color en Hexadeciamal - Ejemplo.- #F06D06, F06D06
 * @param light Number - Cantidad a aumentar o reduir el brillo - Ejemplo.- 20, -20
 */
export function lightenDarkenColor(color, light) {
	return new Promise( async resolve => {
		let r = parseInt(color.substr(1, 2), 16);
		let g = parseInt(color.substr(3, 2), 16);
		let b = parseInt(color.substr(5, 2), 16);

		if (light < 0) {
			r = (1 + light) * r;
			g = (1 + light) * g;
			b = (1 + light) * b;
		} else {
			r = (1 - light) * r + light * 255;
			g = (1 - light) * g + light * 255;
			b = (1 - light) * b + light * 255;
		}

		const R = await hex2(r)
		const G = await hex2(g)
		const B = await hex2(b)
		const RGB = `#${R}${G}${B}`
		resolve(RGB);
	})
}

function hex2(c) {
    return new Promise ( resolve => {
		c = Math.round(c);
		if (c < 0) c = 0;
		if (c > 255) c = 255;

		let s = c.toString(16);
		if (s.length < 2) s = "0" + s;

		resolve(s);
	});
}
